import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import { MessageRow } from './MessageRow.tsx';

const rowStyle = style({ color: 'neutral' });

export const ThinkingIndicator = ({
	reasoningSummary,
	fallback = 'Thinking...',
}: {
	reasoningSummary?: string;
	fallback?: string;
}) => {
	const displayText = reasoningSummary?.trim() || fallback;
	return (
		<MessageRow className={rowStyle}>
			<div className="flex items-center gap-2 py-0.5">
				<span className="flex h-3 w-3 items-center justify-center">
					<span
						className="h-2.5 w-2.5 animate-spin rounded-full border-2
							border-current border-t-transparent"
					/>
				</span>
				<span className="text-xs">{displayText}</span>
			</div>
		</MessageRow>
	);
};
